import { create } from 'zustand';
import { type IdentifiableChatMessage } from '@/types/chat-message';

export interface ChatState {
    init: () => void;
    enabled: boolean;
    guest: boolean;
    visible: boolean;
    text: string;
    target?: IdentifiableChatMessage;
    fallback?: IdentifiableChatMessage;
    show: () => void;
    hide: () => void;
    setEnabled: (enabled: boolean) => void;
    setGuest: (guest: boolean) => void;
    setText: (text: string) => void;
    setTarget: (target?: IdentifiableChatMessage) => void;
    setFallbackTarget: (fallback?: IdentifiableChatMessage) => void;
    clearText: () => void;
    reset: () => void;
}

export const useChatState = create<ChatState>((set) => ({
    init: () => set(() => ({ visible: true, enabled: false, target: undefined, text: "" })),
    enabled: false,
    guest: false,
    visible: true,
    text: "",
    target: undefined,
    fallback: undefined,
    show: () => set(() => ({ visible: true })),
    hide: () => set(() => ({ visible: false })),
    setEnabled: (enabled: boolean) => set(() => ({ enabled: enabled })),
    setGuest: (guest: boolean) => set(() => ({ guest: guest })),
    setText: (text: string) => set(() => ({ text: text })),
    setTarget: (target?: IdentifiableChatMessage) => set(() => ({ target: target })),
    setFallbackTarget: (fallback?: IdentifiableChatMessage) => set(() => ({fallback: fallback})),
    clearText: () => set(() => ({ text: "" })),
    reset: () => set(() => ({ target: undefined, text: "", visible: true }))
}));
